import { Injectable } from '@angular/core';
import { CanActivate, CanLoad, Route, UrlSegment, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';

import { map, mergeMap, first } from 'rxjs/operators';
import { ProfileService } from 'src/app/services/profile/profile.service';
import { LAYOUT_ROUTE } from 'src/app/constants/routes.constants';
import { TokenService } from 'src/app/services/token/token.service';

@Injectable({
  providedIn: 'root'
})
export class PublicGuard implements CanActivate, CanLoad {
  constructor(
    private $router: Router,
    private $profile: ProfileService,
    private $token: TokenService
  ) { }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.handler(state.url.split('/').filter(path => path));
  }
  canLoad(
    route: Route,
    segments: UrlSegment[]
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this.handler(segments.map(segment => segment.path));
  }
  private handler(paths: string[]): any {

    // let observable = this.$profile.changes;
    // if (!this.$profile.isProfileLoaded) {
    //   observable = this.$profile.queryProfile();
    // }
    // if(!this.$token.value){
    //   return false;
    // }else{
    //   return true;
    // }
    if (this.$token.value) {
      this.$router.navigate(['/layout']);
      return false;
    }
    return true;

    //     return observable.pipe(first(), map((profile) => {
    // }));
  }
}
